module.exports = __webpack_public_path__ + "static/media/home_ZT_card_icon.aafeaf78.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/home_ZT_card_icon.png
// module id = 701
// module chunks = 0 1